"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toStaticUrl = exports.toStrutsUrl = exports.toSpaUrl = exports.toApiUrl = exports.decodeUrlCriteria = exports.encodeUrlCriteria = exports.getThirdParty = exports.getMetaInfo = exports.getDomain = exports.getTargetMeta = exports.getEnvZone = exports.getEnv = exports.getStrutsUrl = exports.getStaticUrl = exports.getSpaUrl = exports.getBaseUrl = exports.getApiUrl = exports.isExternal = exports.isInternal = exports.isStaging = exports.isLocal = exports.isTest = exports.isProduction = void 0;
const Presets_1 = require("./Presets");
const urlBuilderTools_1 = require("./Utils/urlBuilderTools");
/**
 *
 * @example
 *
 * ```typescript
 * import { isProduction } from "@mne-core/providers/Target";
 *
 * const isProductionEnv = isProduction();
 * ```
 *
 * @param loc window.location by default
 * @returns true if the environment is our production environment
 */
function isProduction(loc = window.location) {
    const presetKey = (0, Presets_1.presetFromUrl)(loc.host);
    return Boolean(Presets_1.Presets[presetKey].env === "production");
}
exports.isProduction = isProduction;
/**
 *
 * @example
 *
 * ```typescript
 * import { isTest } from "@mne-core/providers/Target";
 *
 * const isTestEnv = isTest();
 * ```
 *
 * @param loc window.location by default
 * @returns true if the environment is our test environment
 */
function isTest(loc = window.location) {
    const presetKey = (0, Presets_1.presetFromUrl)(loc.host);
    return Boolean(Presets_1.Presets[presetKey].env === "test");
}
exports.isTest = isTest;
/**
 *
 * @example
 *
 * ```typescript
 * import { isLocal } from "@mne-core/providers/Target";
 *
 * const isLocalEnv = isLocal();
 * ```
 *
 * @param loc window.location by default
 * @returns true if the environment is local (development)
 */
function isLocal(loc = window.location) {
    const presetKey = (0, Presets_1.presetFromUrl)(loc.host);
    return Boolean(Presets_1.Presets[presetKey].env === "local");
}
exports.isLocal = isLocal;
/**
 *
 * @example
 *
 * ```typescript
 * import { isStaging } from "@mne-core/providers/Target";
 *
 * const isStagingEnv = isStaging();
 * ```
 *
 * @param loc window.location by default
 * @returns true if the environment is our staging environment
 */
function isStaging(loc = window.location) {
    const presetKey = (0, Presets_1.presetFromUrl)(loc.host);
    return Boolean(Presets_1.Presets[presetKey].env === "staging");
}
exports.isStaging = isStaging;
/**
 *
 * @example
 *
 * ```typescript
 * import { isInternal } from "@mne-core/providers/Target";
 *
 * ```
 * @param loc window.location by default
 * @returns true if the environment is considered internal
 */
function isInternal(loc = window.location) {
    const presetKey = (0, Presets_1.presetFromUrl)(loc.host);
    return Boolean(Presets_1.Presets[presetKey].envZone === "internal");
}
exports.isInternal = isInternal;
/**
 *
 * @example
 *
 * ```typescript
 * import { isExternal } from "@mne-core/providers/Target";
 *
 * ```
 * @param loc window.location by default
 * @returns true if the environment is considered external
 */
function isExternal(loc = window.location) {
    const presetKey = (0, Presets_1.presetFromUrl)(loc.host);
    return Boolean(Presets_1.Presets[presetKey].envZone === "external");
}
exports.isExternal = isExternal;
/**
 *
 * @example
 *
 * ```typescript
 * import { getApiUrl } from "@mne-core/providers/Target";
 *
 * const apiUrl = getApiUrl();
 * ```
 *
 * @param loc window.location by default
 * @returns returns the apiUrl to use based on the current environment
 */
function getApiUrl(loc = window.location) {
    const presetKey = (0, Presets_1.presetFromUrl)(loc.host);
    return Presets_1.Presets[presetKey].apiUrl;
}
exports.getApiUrl = getApiUrl;
function getBaseUrl(loc = window.location) {
    const presetKey = (0, Presets_1.presetFromUrl)(loc.host);
    return Presets_1.Presets[presetKey].baseUrl;
}
exports.getBaseUrl = getBaseUrl;
/**
 *
 * @example
 *
 * ```typescript
 * import { getSpaUrl } from "@mne-core/providers/Target";
 *
 * const spaUrl = getSpaUrl();
 * ```
 *
 * @param loc window.location by default
 * @returns returns the spaUrl to use based on the current environment
 */
function getSpaUrl(loc = window.location) {
    const presetKey = (0, Presets_1.presetFromUrl)(loc.host);
    return Presets_1.Presets[presetKey].spaUrl;
}
exports.getSpaUrl = getSpaUrl;
/**
 *
 * @example
 *
 * ```typescript
 * import { getStaticUrl } from "@mne-core/providers/Target";
 *
 * const staticUrl = getStaticUrl();
 * ```
 *
 * @param loc window.location by default
 * @returns returns the staticUrl to use based on the current environment
 */
function getStaticUrl(loc = window.location) {
    const presetKey = (0, Presets_1.presetFromUrl)(loc.host);
    return Presets_1.Presets[presetKey].staticUrl;
}
exports.getStaticUrl = getStaticUrl;
/**
 *
 * @example
 *
 * ```typescript
 * import { getStrutsUrl } from "@mne-core/providers/Target";
 *
 * const strutsUrl = getStrutsUrl();
 * ```
 *
 * @param loc window.location by default
 * @returns returns the strutsUrl to use based on the current environment
 */
function getStrutsUrl(loc = window.location) {
    const presetKey = (0, Presets_1.presetFromUrl)(loc.host);
    return Presets_1.Presets[presetKey].strutsUrl;
}
exports.getStrutsUrl = getStrutsUrl;
/**
 *
 * @example
 *
 * ```typescript
 * import { getEnv } from "@mne-core/providers/Target";
 *
 * const env = getEnv();
 * ```
 *
 * @param loc window.location by default
 * @returns returns the type of environment
 */
function getEnv(loc = window.location) {
    const presetKey = (0, Presets_1.presetFromUrl)(loc.host);
    return Presets_1.Presets[presetKey].env;
}
exports.getEnv = getEnv;
/**
 *
 * @example
 *
 * ```typescript
 * import { getEnv } from "@mne-core/providers/Target";
 *
 * const env = getEnv();
 * ```
 *
 * @param loc window.location by default
 * @returns returns the type of environment
 */
function getEnvZone(loc = window.location) {
    const presetKey = (0, Presets_1.presetFromUrl)(loc.host);
    return Presets_1.Presets[presetKey].envZone;
}
exports.getEnvZone = getEnvZone;
/**
 *
 * @example
 *
 * ```typescript
 * import { getTargetMeta } from "@mne-core/providers/Target";
 *
 * const { apiUrl, domain, metaInfo, env, ...rest} = getTargetMeta();
 * ```
 *
 * @param loc window.location by default
 * @returns returns the full target object based on your current location object
 */
function getTargetMeta(loc = window.location) {
    const presetKey = (0, Presets_1.presetFromUrl)(loc.host);
    const preset = Presets_1.Presets[presetKey];
    const targetMeta = {
        apiUrl: getApiUrl(loc),
        baseUrl: getBaseUrl(loc),
        domain: getDomain(loc),
        metaInfo: getMetaInfo(loc),
        spaUrl: getSpaUrl(loc),
        staticUrl: getStaticUrl(loc),
        strutsUrl: getStrutsUrl(loc),
        thirdParty: getThirdParty(loc),
        env: getEnv(loc),
        envZone: getEnvZone(loc),
        domains: preset.domains,
    };
    return targetMeta;
}
exports.getTargetMeta = getTargetMeta;
/**
 *
 * @example
 *
 * ```typescript
 * import { getDomain } from "@mne-core/providers/Target";
 *
 * const domain = getDomain();
 * ```
 *
 * @param loc window.location by default
 * @returns returns the domain based on your current location object
 */
function getDomain(loc = window.location) {
    const presetKey = (0, Presets_1.presetFromUrl)(loc.host);
    return Presets_1.Presets[presetKey].domain;
}
exports.getDomain = getDomain;
/**
 *
 * @example
 *
 * ```typescript
 * import { getMetaInfo } from "@mne-core/providers/Target";
 *
 * const { email, phoneNumber, ...rest} = getMetaInfo();
 * ```
 *
 * @param loc window.location by default
 * @returns returns the {@link IMetaInfo } object based on your current location object
 */
function getMetaInfo(loc = window.location) {
    const presetKey = (0, Presets_1.presetFromUrl)(loc.host);
    return Presets_1.Presets[presetKey].metaInfo;
}
exports.getMetaInfo = getMetaInfo;
/**
 *
 * @example
 *
 * ```typescript
 * import { getThirdParty } from "@mne-core/providers/Target";
 *
 * const thirdParty = getThirdParty();
 * ```
 *
 * @param loc window.location by default
 * @returns returns the thirdParty oject based on your current location object
 */
function getThirdParty(loc = window.location) {
    const presetKey = (0, Presets_1.presetFromUrl)(loc.host);
    return Presets_1.Presets[presetKey].thirdParty;
}
exports.getThirdParty = getThirdParty;
/**
 *
 * A function to encode criteria object so that they can be used in a url string.
 * The encodeUrlCriteria is intended used together with decodeUrlCriteria
 *
 * @example
 *
 * ```typescript
 * import { encodeUrlCriteria } from "@mne-core/providers/Target";
 *
 * const myEncodedCriteriaString = encodeUrlCriteria({ a: 1, b: { c: "hello"} });
 * ```
 *
 * @param criteria A criteria object
 * @returns The encoded object. It can be decoded with decodeUrlCriteria
 */
function encodeUrlCriteria(criteria) {
    return btoa(encodeURIComponent(JSON.stringify(criteria)));
}
exports.encodeUrlCriteria = encodeUrlCriteria;
/**
 *
 * A function to decode criteria object from a url string.
 * The decodeUrlCriteria is intended used together with encodeUrlCriteria
 *
 * @example
 *
 * ```typescript
 * import { decodeUrlCriteria } from "@mne-core/providers/Target";
 *
 * const myCriteria = decodeUrlCriteria(myEncodedString);
 * ```
 *
 * @param criteria A criteria object
 * @returns The encoded object. It can be decoded with decodeUrlCriteria
 */
function decodeUrlCriteria(s) {
    return JSON.parse(decodeURIComponent(atob(s)));
}
exports.decodeUrlCriteria = decodeUrlCriteria;
/**
 * @param to
 * @param loc
 * @default window.location
 *
 */
function toApiUrl(path, loc = window.location) {
    if (typeof path === "string") {
        const apiStringUrl = new URL((0, urlBuilderTools_1.trimTrailingSlash)(getApiUrl(loc)) + (0, urlBuilderTools_1.normalizePath)(path));
        apiStringUrl.pathname = (0, urlBuilderTools_1.normalizePath)(apiStringUrl.pathname);
        apiStringUrl.hash = "";
        return apiStringUrl.toString();
    }
    const apiUrl = new URL(getApiUrl(loc));
    const apiPath = (0, urlBuilderTools_1.normalizePath)(apiUrl.pathname);
    const relPath = (0, urlBuilderTools_1.normalizePath)(path.pathname);
    apiUrl.pathname = (0, urlBuilderTools_1.normalizePath)(apiPath + relPath);
    apiUrl.search = (0, urlBuilderTools_1.buildSearchString)(path.search || "");
    apiUrl.hash = "";
    return apiUrl.toString();
}
exports.toApiUrl = toApiUrl;
function toSpaUrl(path, loc = window.location) {
    if (typeof path === "string") {
        const spaStringUrl = new URL((0, urlBuilderTools_1.trimTrailingSlash)(getSpaUrl(loc)) + (0, urlBuilderTools_1.normalizePath)(path));
        spaStringUrl.pathname = (0, urlBuilderTools_1.normalizePath)(spaStringUrl.pathname);
        return spaStringUrl.toString();
    }
    const spaUrl = new URL(getSpaUrl(loc));
    spaUrl.pathname = (0, urlBuilderTools_1.buildRelativePath)(spaUrl.pathname, loc.pathname, path.pathname);
    spaUrl.search = (0, urlBuilderTools_1.buildSearchString)(path.search || "");
    spaUrl.hash = path.hash || "";
    return spaUrl.toString();
}
exports.toSpaUrl = toSpaUrl;
function toStrutsUrl(path, loc = window.location) {
    if (typeof path === "string") {
        const strutsStringUrl = new URL((0, urlBuilderTools_1.trimTrailingSlash)(getStrutsUrl(loc)) + (0, urlBuilderTools_1.normalizePath)(path));
        strutsStringUrl.pathname = (0, urlBuilderTools_1.normalizePath)(strutsStringUrl.pathname);
        return strutsStringUrl.toString();
    }
    const strutsUrl = new URL(getStrutsUrl(loc));
    const strutsPath = (0, urlBuilderTools_1.normalizePath)(strutsUrl.pathname);
    const relPath = (0, urlBuilderTools_1.normalizePath)(path.pathname);
    strutsUrl.pathname = (0, urlBuilderTools_1.normalizePath)(strutsPath + relPath);
    strutsUrl.search = (0, urlBuilderTools_1.buildSearchString)(path.search || "");
    strutsUrl.hash = path.hash || "";
    return strutsUrl.toString();
}
exports.toStrutsUrl = toStrutsUrl;
function toStaticUrl(path, loc = window.location) {
    if (typeof path === "string") {
        const staticStringUrl = new URL((0, urlBuilderTools_1.trimTrailingSlash)(getStaticUrl(loc)) + (0, urlBuilderTools_1.normalizePath)(path));
        staticStringUrl.pathname = (0, urlBuilderTools_1.normalizePath)(staticStringUrl.pathname);
        return staticStringUrl.toString();
    }
    const staticUrl = new URL(getStaticUrl(loc));
    const staticPath = (0, urlBuilderTools_1.normalizePath)(staticUrl.pathname);
    const relPath = (0, urlBuilderTools_1.normalizePath)(path.pathname);
    staticUrl.pathname = (0, urlBuilderTools_1.normalizePath)(staticPath + relPath);
    staticUrl.search = (0, urlBuilderTools_1.buildSearchString)(path.search || "");
    staticUrl.hash = path.hash || "";
    return staticUrl.toString();
}
exports.toStaticUrl = toStaticUrl;
